//import Swal from 'sweetalert2'

$(document).ready(function() {
    const companies = {
        isLoading: false,
        init() {
            $(document).on('click', '#add-new-company', this, this.addNewCompany);
            $(document).on('click', '#cancel-new-company', this, function() {
				$('#new-company-form-wrapper').hide();
			});
			$(document).on('click', '.cancel-edit-company', this, function() {
				var id = $(this).data('id');

				$('#company-' +id).find('.form-control').prop('disabled', true);
				$('#company-' +id).find('.save-company').hide();
				$('#company-' +id).find('.cancel-edit-company').hide();
				$('#company-' +id).find('.edit-company').show();
				$('#company-' +id).find('.company-name').html(response.data.name);
			});
            $(document).on('click', '.edit-company', this, this.editCompany);
            $(document).on('click', '.save-company', this, this.updateCompany);
            $(document).on('click', '#save-new-company', this, this.saveCompany);
            $(document).on('click', '.delete-company', this, this.deleteCompany);

			$('.edit-company-select2').select2({
				disabled: true
			});
        },
		editCompany(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

			$('#company-' +id).find('.form-control').removeAttr('disabled');
			$('#company-' +id).find('.save-company').show();
			$('#company-' +id).find('.cancel-edit-company').show();
			$('#company-' +id).find('.edit-company').hide();
			$('#company-' +id).find('.edit-company-select2').select2({
				disabled: false
			});

		},
		updateCompany(event) {
            const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

            if (_this.isLoading) {
                return false;
            }

            $('#company-' + id).find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#edit-name-' + id).val() == '') {
				$('#edit-name-' + id).addClass('is-invalid');
				errors = true;
			}
			if ($('#edit-cui_number-' + id).val() == '') {
				$('#edit-cui_number-' + id).addClass('is-invalid');
				errors = true;
			}
			if ($('#edit-address-' + id).val() == '') {
				$('#edit-address-' + id).addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoading = true;

			var values = '_token=' + $('#_token_company_list').val();
            values += '&id=' + id;
            values += '&name=' + $('#edit-name-' + id).val();
            //values += '&cui_attribute=' + $('#company-cui-attribute').val();
            values += '&cui_number=' + $('#edit-cui_number-' + id).val();
            values += '&nr_reg_com=' + $('#edit-nr_reg_com-' + id).val();
            //values += '&nr_reg_com_2=' + $('#company-nrregcom-2').val();
            //values += '&nr_reg_com_3=' + $('#company-nrregcom-3').val();
            //values += '&nr_reg_com_4=' + $('#company-nrregcom-4').val();
            values += '&bank=' + $('#edit-bank-' + id).val();
            values += '&bank_account=' + $('#edit-bank_account-' + id).val();
            //values += '&county=' + $('#company-county option:selected').val();
            //values += '&city=' + $('#company-city option:selected').val();
			//values += '&country_id=' + $('#edit-country_id-' + id + ' option:selected').val();
			//values += '&county=' + $('#company-county').val();
            values += '&city_id=' + $('#edit-city_id-' + id).val();
            values += '&address=' + $('#edit-address-' + id).val();
            //values += '&zip_code=' + $('#company-zip-code').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/update-company`,
                data: values,
                beforeSend: function() {
                    _this.isLoading = true;
                },
                complete: function() {
                    _this.isLoading = false;
                },
                success: function(response, xhr) {
                    _this.isLoading = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {

						$('#company-' +id).find('.form-control').prop('disabled', true);
						$('#company-' +id).find('.save-company').hide();
						$('#company-' +id).find('.company-name').html(response.data.name);
						$('#company-' +id).find('.cancel-edit-company').hide();
						$('#company-' +id).find('.edit-company').show();
						// $('#company-' +id).find('.edit-company-select2').select2({
						// 	disabled: true
						// });

						Swal.fire({
							// icon: 'success',
							// title: 'Success!',
							html: response.message
						});

						return;
                    }

					Swal.fire({
						// icon: 'error',
						// title: 'Error!',
						html: response.message
					});
                },
                error(error) {
                    _this.isLoading = false;
                },
            });
        },
        deleteCompany(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if (!id) { return false; }

			Swal.fire({
				title: $('#companies-container').data('delete-title'),
				text: $('#companies-container').data('delete-text'),
				icon: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: $('#companies-container').data('delete-btn-yes'),
				cancelButtonText: $('#companies-container').data('delete-btn-no')
			}).then((result) => {

				if (!result.isConfirmed) {
					return false;
				}

				if (_this.isLoading) {
	                return false;
	            }

				//Loading...
	            _this.isLoading = true;

	            var values = '_token=' + $('#_token_company_list').val();
				values += '&id=' + id;
	            $.ajax({
	                type: "POST",
	                url: `${baseURL}/account/delete-company`,
	                data: values,
	                beforeSend: function() {
	                    _this.isLoading = true;
	                },
	                complete: function() {
	                    _this.isLoading = false;
	                },
	                success: function(response, xhr) {
	                    _this.isLoading = false;

	                    if (response.status == 1) {
							$('#company-' + id).remove();
							Swal.fire(
								$('#companies-container').data('delete-success-title'),
								$('#companies-container').data('delete-success-text'),
								'success'
		    				);

							if ($('#companies-container').children().length == 0){
								$('#companies-container').html('<p class="empty">'+$('#companies-container').data('empty-text')+'</p>');
							} else {
								//console.log('is not epmtpy');
							}

							return;
	                    }
	                },
	                error(error) {
	                    _this.isLoading = false;
	                },
	            });

  				//if (result.value) {}
			});
		},
        addNewCompany(event) {
			const _this = event.data;

			$('#new-company-form-wrapper').show();

			$('.select2').select2();
		},
        saveCompany(event) {
            const _this = event.data;
			const source = $(this).data('source');

            if (_this.isLoading) {
                return false;
            }

            $('.form-new-company').find('.is-invalid').removeClass('is-invalid');

			var errors = false;
			if ($('#name').val() == '') {
				$('#name').addClass('is-invalid');
				errors = true;
			}
			if ($('#cui_number').val() == '') {
				$('#cui_number').addClass('is-invalid');
				errors = true;
			}
			if ($('#address').val() == '') {
				$('#address').addClass('is-invalid');
				errors = true;
			}
			// if ($('#country_id option:selected').val() == '') {
			// 	$('#country_id').addClass('is-invalid');
			// 	errors = true;
			// }
			if ($('#city_id').val() == '') {
				$('#city_id').addClass('is-invalid');
				errors = true;
			}
			if (errors) {
				return false;
			}

            //Loading...
            _this.isLoading = true;

            var values = '_token=' + $('#_token_company').val();
            values += '&name=' + $('#name').val();
            //values += '&cui_attribute=' + $('#company-cui-attribute').val();
            values += '&cui_number=' + $('#cui_number').val();
            values += '&nr_reg_com=' + $('#nr_reg_com').val();
            //values += '&nr_reg_com_2=' + $('#company-nrregcom-2').val();
            //values += '&nr_reg_com_3=' + $('#company-nrregcom-3').val();
            //values += '&nr_reg_com_4=' + $('#company-nrregcom-4').val();
            values += '&bank=' + $('#bank').val();
            values += '&bank_account=' + $('#bank_account').val();
            //values += '&county=' + $('#company-county option:selected').val();
            //values += '&city=' + $('#company-city option:selected').val();
			//values += '&country_id=' + $('#country_id option:selected').val();
			//values += '&county=' + $('#company-county').val();
            values += '&city_id=' + $('#city_id').val();
            values += '&address=' + $('#address').val();
            //values += '&zip_code=' + $('#company-zip-code').val();

            $.ajax({
                type: "POST",
                url: `${baseURL}/account/company`,
                data: values,
                beforeSend: function() {
                    _this.isLoading = true;
                },
                complete: function() {
                    _this.isLoading = false;
                },
                success: function(response, xhr) {
                    _this.isLoading = false;

                    if (response.status == 0) {
                        var errorsHtml = '';
                        for(var errorKey in response.errors) {

                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#"+errorKey).addClass('is-invalid');
                            }
                        }

                        return false;
                    }

                    if (response.status == 1) {
						if(source == 'reservation-page') {
							$('#billing-companies-wrapper .empty').remove();

							var rowHtml = `<div class="row wrap-row billing-company"
												data-id="${response.data.id}"
												id="billing-company-${response.data.id}">
								<div class="col-sm-12 col-md-12">
									<div class="radio-box"></div>
									<div class="info">
										<div class="company-contact">${response.data.name}</div>
										<div class="company-text">${response.data.cui}</div>
										<div class="company-text">${response.data.address}${(response.data.city!=''?', ' + response.data.city:'')}</div>
									</div>
								</div>
							</div>`;
							$('#billing-companies-wrapper').prepend(rowHtml);

	                        $('#billing-company-modal').modal('hide');
							$('#billing-company-modal').html('');
						} else {
							$('.empty').remove();

							var selectOptions = '';
							for (var i in countriesArray) {
								var selectedOption = '';
								if (countriesArray[i].id == response.data.country_id) {
									selectedOption = 'selected="selected"';
								}
								selectOptions += '<option value="'+countriesArray[i].id+'" '+selectedOption+'>'+countriesArray[i].name+'</option>';
							}

							var rowHtml = `<div id="company-${response.data.id}" class="mb-4">
								<div class="section-divider row mb-4">
									<div class="col-auto company-name">${response.data.name}</div>
									<div class="col line"></div>
								</div>
								<div class="row">
									<div class="col-md-6 mb-3">
										<label for="edit-name-${response.data.id}" class="form-label">Denumire *</label>
										<input type="text" class="form-control" name="edit-name-${response.data.id}" id="edit-name-${response.data.id}" value="${response.data.name}" disabled>
									</div>
									<div class="col-md-6 mb-3">
										<label for="edit-nr_reg_com-${response.data.id}" class="form-label">Nr. Registrul Comerțului</label>
										<input type="text" class="form-control" name="edit-nr_reg_com-${response.data.id}" id="edit-nr_reg_com-${response.data.id}" value="${response.data.nr_reg_com}" disabled>
									</div>
									<div class="col-md-6 mb-3">
										<label for="edit-cui_number-${response.data.id}" class="form-label">CUI *</label>
										<input type="text" class="form-control" name="edit-cui_number-${response.data.id}" id="edit-cui_number-${response.data.id}" value="${response.data.cui}" disabled>
									</div>
									<div class="col-md-6 mb-3">
										<label for="edit-address-${response.data.id}" class="form-label">Adresă sediu *</label>
										<input type="text" class="form-control" name="edit-address-${response.data.id}" id="edit-address-${response.data.id}" value="${response.data.address}" disabled>
									</div>
									<div class="col-md-6 mb-3">
										<label for="edit-city_id-${response.data.id}" class="form-label">Oraș *</label>
										<input type="text" class="form-control" name="edit-city_id-${response.data.id}" id="edit-city_id-${response.data.id}" value="${response.data.city_id}" disabled>
									</div>
									<div class="col-md-6 mb-3">
										<label for="edit-bank-${response.data.id}" class="form-label">Banca</label>
										<input type="text" class="form-control" name="edit-bank-${response.data.id}" id="edit-bank-${response.data.id}" value="${response.data.bank}" disabled>
									</div>
									<div class="col-md-6 mb-3">
										<label for="edit-bank_account-${response.data.id}" class="form-label">Cont IBAN</label>
										<input type="text" class="form-control" name="edit-bank_account-${response.data.id}" id="edit-bank_account-${response.data.id}" value="${response.data.bank_account}" disabled>
									</div>
								</div>
								<div class="row gy-2 mx-0 mt-2">
									<button style="display: none;padding: 10px 20px!important;font-size:12px!important" type="button" data-id="${response.data.id}" 
										class="save-company  btn purple-btn-cart mt-2 col-md-3 rounded-pill text-uppercase me-2" ><i class="fa fa-spinner fa-spin" aria-hidden="true" style="display:none"></i>salveaza</button>
									<button style="padding: 10px 20px!important;font-size:12px!important;display:none;" data-id="${response.data.id}" 
										class="btn purple-btn-outline mt-2 col-md-3 rounded-pill text-uppercase cancel-edit-company me-2"  >cancel</button>
									<button style="padding: 10px 20px!important;font-size:12px!important" data-id="${response.data.id}" 
										class="btn purple-btn-cart mt-2 col-md-3 rounded-pill text-uppercase edit-company me-2"  >editeaza</button>
									<button style="padding: 10px 20px!important;font-size:12px!important" data-id="${response.data.id}" 
										class="delete-company btn purple-btn-outline mt-2 col-md-3 rounded-pill text-uppercase">sterge</button>
								</div>
							</div>`;
							$('#companies-container').prepend(rowHtml);

	                        $('#new-company-form-wrapper').hide();
							$('#form-new-company').find('.form-control').val('');

							$('.edit-company-select2').select2({
								disabled: true
							});

							Swal.fire({
								// icon: 'success',
								// title: 'Success!',
								html: response.message
							});
						}

						return;
                    }
                },
                error(error) {
                    _this.isLoading = false;
                },
            });
        },

    };

    if ($('.account-companies-section').length) {
        companies.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/companies.js